const riot = require('riot');

riot.tag2('modal-record', '<form class="w300 modal bg-white s-w-full rounded-8 p32" ref="modal" onsubmit="{submit}"> <label class="block mb16"> <div>record-title</div> <input class="input w-full" ref="title" type="text" autofocus> </label> <label class="block mb16"> <div>project</div> <select class="select w-full" ref="project" size="8"> <option value="">未設定</option> <option each="{project in projects}" riot-value="{project.id}">{project.data.name}</option> </select> </label> <label class="block mb16"> <div>タグ</div> <div ref="tags" data-is="atom-input-tags"></div> </label> <div> <div>start: {dayjs(opts.item.data.start_at).format(\'HH:mm\')}</div> <div>end: {dayjs(opts.item.data.end_at).format(\'HH:mm\')}</div> </div> <div class="f fbw" if="{!opts.item || opts.item.data.is_recording !== true}"> <button class="mr8" type="button" onclick="{onDelete}"><i class="material-icons">delete</i></button> <button class="button primary">更新</button> </div> </form>', 'modal-record,[data-is="modal-record"]{background-color:rgba(0,0,0,0.5)}', 'class="f fh s-px8" spat-animation="push"', function(opts) {
    this.on('mount', async () => {
      if (this.opts.item) {
        this.refs.title.value = this.opts.item.data.title;
      }

      var projects = await app.store.collection('projects').fetch();
      projects.sort((a, b) => a.data.name.toLowerCase() < b.data.name.toLowerCase() ? -1 : 1);

      this.update({
        projects,
      });

      if (this.opts.item) {
        if (this.opts.item.relation.project && this.opts.item.relation.project.doc.exists) {
          var currentProject = this.projects.find(p => p.id === this.opts.item.data.project_ref.id);

          if (currentProject) {
            this.refs.project.value = currentProject.id;
          }
        }

        if (this.opts.item.data.tags) {
          this.refs.tags.setValues(opts.item.data.tags);
        }
      }

      this.refs.title.focus();
      this.refs.title.select();
    });

    this.submit = async (e) => {
      e.preventDefault();

      var project = null;
      if (this.refs.project.value) {
        project = this.projects.find(p => p.id === this.refs.project.value);
      }

      var data = {
        title: this.refs.title.value,
        project,
        tags: this.refs.tags.getValues(),
      };

      if (this.opts.item) {
        this.trigger('submit', {
          data,
        });
      }

      else {
        this.trigger('create', {
          data,
        });
      }

      this.close();
    };

    this.onDelete = () => {
      this.trigger('delete');

      this.close();
    };
});